import React from 'react';
import { FaqDropdown } from '../../../components/faq-dropdown';
import { Main } from '../../../layouts/main';
import { Container } from './styles';

const initialState = {
  0: false,
  1: false,
  2: false
};
export const Secretariat: React.FC = () => {
  
  const [state, setState] = React.useState(initialState);
  
  return (
    <Main>
      <Container>
      <FaqDropdown
        marginTop={1}
        state={state[0]}
        content={'Não consigo cadastrar no aplicativo, como deve proceder?'}
        onClick={() => {
          setState((old) => (old = { ...initialState, 0: !old[0] }));
        }}
      > 
      O aplicativo é de USO EXCLUSIVO do Cirurgião. o cadastro do secretariado deve ser através do PORTAL WEB.
      <br/>Não esqueça o secretariado é linkado ao Cirurgião através da indicação do próprio cirurgião.
    </FaqDropdown>
      <FaqDropdown
        marginTop={1}
        state={state[1]}
        content={'O secretariado pode cadastrar antes do cirurgião? '}
        onClick={() => {
          setState((old) => (old = { ...initialState, 1: !old[1] }));
        }}
      >
      Sim. Mas somente será linkado após a indicação do cirurgião.
    </FaqDropdown>
      <FaqDropdown
        marginTop={1}
        state={state[2]}
        content={'Um secretariado pode manejar dois ou mais cirurgiões?'}
        onClick={() => {
          setState((old) => (old = { ...initialState, 2: !old[2] }));
        }}
      >
      Sim. Não existe limite de cirurgiões por secretário(a), mas um cirurgião só pode estar linkado a um secretariado.
    </FaqDropdown>
        
      </Container>
    </Main>
  );
}
